<template>
    <div>
        <template v-if="action=='view'">
        <div class="table-settings mb-4" v-if="allData.count>0">
            <div class="row align-items-center justify-content-between">
                <div class="col col-md-6 col-lg-3 col-xl-4">
                    <!-- <div class="input-group">
                        <span class="input-group-text" id="basic-addon2"><span class="fa fa-search"></span></span>
                        <input v-model="q" type="search" class="form-control" id="exampleInputIconLeft" placeholder="Search" aria-label="Search" aria-describedby="basic-addon2">
                    </div> -->
                </div>
                <div class="col-4 col-md-2 col-xl-1 pl-md-0 text-right">
                </div>
            </div>
        </div>
        <div class="card border-light shadow-sm mb-4">
        <div class="card-body" v-if="loading==false && (allData.count>0 || q!='')">
            <table class="table table-hover">
                <thead class="thead-light">
                    <tr>
                        <th>#</th>
                        <th>Heading</th>
                        <th>Image</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody v-if="allData.count>0">
                    <tr v-for="data in allData.data" :key="data.id">
                        <td>
                            <a href="#" class="font-weight-bold">
                                {{data.id}}
                            </a>
                        </td>
                        <td><span class="font-weight-normal">{{data.heading}}</span></td>
                        <!-- <td> {{data.description}} </td> -->
                        <td><span class="font-weight-normal">  
                            <img v-if="data.image!=''" :src="$root.URL_ROOT+'uploads/Content/'+data.image" width="50"></span></td>

                        <td><span class="font-weight-bold">
                           <a class="btn btn-danger btn-xs" href="#" @click="update('mss_site_content',1,data.id);data.status=1" v-if="data.status==0">  Inactive</a>
                                    <a class="btn btn-success btn-xs" href="#" @click="update('mss_site_content',0,data.id);data.status=0" v-if="data.status==1"> Active</a>
                               </span></td>
                        <td>
                            <div class="btn-group">
                                <router-link class="btn btn-primary btn-xl" :to="{name : 'index', params: { page: page, action: 'edit', id: data.id }}"><span class="fa fa-edit mr-2"></span>Edit</router-link>
                            <!-- <a @click="remove(data.id)" class="btn btn-danger btn-xs" href="#"><span class="fa fa-trash-alt mr-2"></span>Remove</a> -->

                            </div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td class="text-center" colspan="5">No record found</td>
                    </tr>
                </tbody>
            </table>
            <div class="card-footer px-3 border-0 d-flex align-items-center justify-content-between">
                <nav aria-label="Page navigation example">
                    <ul class="pagination mb-0">
                        <template v-for="(paginate,key) in allData.links">
                            <li :key="key" class="page-item" :class="{'active': paginate.active}" v-if="paginate.url">
                                <a class="page-link" @click="viewAllUrl=paginate.url;allDatas(false)" v-html="paginate.label"></a>
                            </li>
                        </template>
                    </ul>
                </nav>
                <div class="font-weight-bold small">Page <b>{{allData.current_page}}</b> of <b>{{allData.last_page}}</b> page Total record <b>{{allData.total}}</b></div>
            </div>
        </div>
        <div class="card-body text-center" v-else>
            <div v-if="loading">
                loading...
            </div>
            <div v-else>
                <!-- <InlineSvg name="nopage"></InlineSvg> -->
                <div>
                    <h3>Add and manage your {{page}}</h3>
                    <p>This is where you’ll add {{page}} and manage your website. You can also improve your seo for {{page}} by adding.</p>
                    <router-link :to="{name : 'index', params: { page: page, action: 'add' }}" class="btn btn-primary" type="button">Add {{page}}</router-link>
                    <br><br><br>
                </div>
            </div>
        </div>
        </div>
        </template>
        <template v-else>
            <div class="row">
                <div class="col-12 col-xl-8">
                    <div class="card card-body bg-white border-light shadow-sm mb-4">
                        <h2 class="h5 mb-4">General information  </h2>
                        <div class="row">
                            <!-- <div class="col-md-6 mb-3">
                                <MssInput v-model="form.linkname" placeholder="Enter Page Link" required></MssInput>
                            </div> -->
                            <div class="col-md-6 mb-3">
                                <MssInput v-model="form.heading" placeholder="Enter Name" required></MssInput>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label>Image</label>
                                 <i>(Upload Image size max 1MB) </i>
                                <input class="form-control" type="file" id="file" ref="content_image" accept="image/*" />
                                <div v-if="action=='edit'">
                                <img v-if="form.image!=''" :src="$root.URL_ROOT+'uploads/Content/'+form.image" width="100">
                                </div>
                            </div>
                 
                        </div>
                           <div class="row align-items-center">
                            <div class="col-md-12 mb-3">
                                <div class="pull-right"><MssInput type="switch" v-model="isEditor" :placeholder="isEditor ? 'Source Code' : 'View Editor'"></MssInput></div>
                                <label for="birthday">Page Body <span> (Optional) </span> </label>
                                <vue-editor v-if="isEditor" v-model="form.description" :editorToolbar="fullToolbar"></vue-editor>
                                <MssInput v-else type="textarea" v-model="form.description"></MssInput>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-xl-4 sidebar-stricky">
                    <div class="card card-body bg-white border-light shadow-sm mb-4">
                        <h2 class="h5 mb-4">Visibility</h2>
                        <div class="row">
                            <div class="col-md-12 mb-3">
                                <MssInput type="switch" v-model="form.status" placeholder="Visible this page to all"></MssInput>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div>
                                    <button @click="submit" class="btn btn-info btn-block" v-if="action=='add'">Publish</button>
                                    <button @click="submit" class="btn btn-success btn-block" v-else>Update</button>
                                </div>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import axios from 'axios'
import $ from 'jquery'
import { VueEditor } from "vue2-editor";

export default {
    components: {
        VueEditor
    },
    props:[
        "page","action","id"
    ],
    data() {
        return {
            isEditor: true,
            q:'',
            loading: false,
            allData: [],
            form: {
                id:null,
                status: true,
                content_type:'home_content-2',
                description: '',
                content_image: '',
                type:'save_site_content'
            },
            editSEO: false,
            defaultSEO: true,
            pageList:[],
            fullToolbar : [
                [{ 'font': [] }],
                [{ 'header': [false, 1, 2, 3, 4, 5, 6, ] }],
                [{ 'size': ['small', false, 'large', 'huge'] }],
                ['bold', 'italic', 'underline', 'strike'],
                [{'align': [false,'justify','center','right']}],
                //[{ 'header': 1 }, { 'header': 2 }],
                //['blockquote', 'code-block'],
                [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
                //[{ 'script': 'sub'}, { 'script': 'super' }],
                [{ 'indent': '-1'}, { 'indent': '+1' }],
                [{ 'color': [] }, { 'background': [] }],
                ['link', 'image', 'video', 'formula'],
                //[{ 'direction': 'rtl' }],
                ['clean'],
            ],
            viewAllUrl:''
        }
    },
    methods: {
        update(table,status,id){
            var param = {
                id: id,
                status:status,
                table:table,
                type:'commonStatus'
            }
             axios({
                method: 'POST',
                url: this.$root.URL_ROOT+'api.php',
                data: param
            }).then(function (response) {
                var data = response.data;
                console.log('status',data)
            })
        },
        addInit(){
            this.getUnderof();
            this.reset()
        },
        editInit(){
            this.getDetail();
            this.getUnderof();
        },
        viewInit(){
            this.viewAllUrl=this.URL_ROOT+'admin/'+this.page+'/all'
            this.allDatas(true)
        },
        reset(){
            this.form = {
                id:null,
                status: true,
                content_type:'home_content-2',
                description: '',
                content_image: '',
                type:'save_site_content'

            };
        },
        getUnderof(){
            var pList=[];
            pList.push({label: 'Primary Menu', code: 0})
            $.ajax({
                "method": 'GET',
                "url": this.URL_ROOT+'admin/'+this.page+'/allpage/?field=heading,id,underof',
                "success": (response)=>{
                    if(response.status=="success"){
                        console.log(response.data);
                        $.each(response.data, function(key,param) {
                            //console.log(param,key);
                            pList.push({label: param.heading, code: param.id})
                        })
                    }
                    this.pageList = pList;
                }
            })
            /**
             if(this.action=="add"){
                this.from.lorder = response.length+1;
            } */
        },
        getDetail(){
            var ev = this
            var param = {
                id: this.id,
                type:'getSingleSiteContent'
            }
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT+'api.php',
                data: param
            }).then(function (response) {
                console.log(response)
                var data = response.data;
                ev.form = data
                ev.form.setting_type = data.type
            })
        },
        allDatas(){
            var ev = this
            axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'api.php',
                    data: {
                        type: 'getSiteContent',
                        content_type:'home_content-2'
                    }
                }).then(function (response) {
                var data = response.data;
                ev.allData = data
                })
        },
        submit() {
            var ev = this
            this.file = this.$refs.content_image.files[0];
            let formData = new FormData();
            if (this.form.heading == '' && this.from.heading == 'undefined') {
                this.$toasted.global.error({
                    message: 'Please enter Heading'
                })
            }else if (this.file == ''  && this.from.heading == 'undefined') {
                this.$toasted.global.error({
                    message: 'Please Select Image'
                })
            }else{
            var status = ''
            if(ev.form.status==true){
                status = 1
            }else{
                status = 0
            }
            if(this.action=='edit'){
            this.form.type = 'edit_site_content';
            this.form.content_type = 'home_content-2';
            formData.append('id', this.id);
            }
            formData.append('content_type', ev.form.content_type);
            formData.append('heading', ev.form.heading);
            formData.append('description', ev.form.description);
            formData.append('content_image', ev.file);
            formData.append('status', status);
            formData.append('type', ev.form.type);
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT+'api.php',
                data: formData
            }).then(function (response) {
                var data = response.data;
                console.log(response)
                    if (data.status == "success") {
                        ev.$swal({
                            toast: true,
                            position: 'top-end',
                            timer: 5000,
                            icon: 'success',
                            timerProgressBar: true,
                            title: 'Action perform successfully'
                        })
        //  window.location.href = 'index/'+ev.page;
                        ev.$router.push({
                            name: 'index',
                            params: {
                                page: ev.page,
                            }
                        })
                    } else {
                        setTimeout(() => ev.$swal(data.msg), 1000);

                    }

                }
            )
            }
        },
        remove(id) {
            var self = this;
             var param = {
                id: id,
                table:'mss_site_content',
                type:'commonDelete'
            }
            this.$swal({
                title: "Delete this ?",
                text: "Are you sure? You won't be able to revert this!",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: "#f00",
                confirmButtonText: "Yes, Delete it!",
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    axios({
                method: 'POST',
                url: this.$root.URL_ROOT+'api.php',
                data: param
            }).then(function (response) {
                var data = response.data;
                self.allDatas()
                console.log('commonDelete',data)
            })
                }
            })
        },
        
    },
    mounted(){
        if(this.action=="view"){
            this.viewInit()
        }else if(this.action=="edit" && this.id>0){
            this.editInit()
        }else if(this.action=="add"){
            this.addInit();
        }
    },
    watch: {
        'action': function(val) {
            if(val=="view"){
                this.viewInit()
            }else if(val=="edit" && this.id>0){
                this.editInit()
            }else if(val=="add"){
                this.addInit();
            }
        },
    }
}
</script>
<style scoped>
@import "~vue2-editor/dist/vue2-editor.css";

</style>
